var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_368_5460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66603 4.66412C1.20052 6.86099 1.20052 9.13104 1.66603 11.3279C1.7272 11.551 1.84538 11.7543 2.00896 11.9179C2.17253 12.0815 2.37587 12.1997 2.59896 12.2608C6.17304 12.8531 9.82023 12.8531 13.3943 12.2608C13.6174 12.1997 13.8207 12.0815 13.9843 11.9179C14.1479 11.7543 14.2661 11.551 14.3272 11.3279C14.7928 9.13104 14.7928 6.86099 14.3272 4.66412C14.2661 4.44102 14.1479 4.23769 13.9843 4.07411C13.8207 3.91054 13.6174 3.79235 13.3943 3.73119C9.82022 3.13908 6.17305 3.13908 2.59896 3.73119C2.37587 3.79235 2.17253 3.91054 2.00896 4.07411C1.84538 4.23769 1.7272 4.44102 1.66603 4.66412Z",
    stroke: "#FB2C36",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66382 9.99632L9.99571 7.99718L6.66382 5.99805V9.99632Z",
    stroke: "#FB2C36",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_5460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9931,
    height: 15.9931,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b916b0f2ba25cf5c420d6540c9f8dc0f.svg";
export { ForwardRef as ReactComponent };